<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">header</slot>
          </div>

          <div class="modal-body">
            <slot name="body">body</slot>
          </div>

          <div class="modal-footer">
            <slot name="buttons">buttons</slot>
            <b-button :size="'large'" :variant="'secondary'" @click="$emit('close')" class="active-item"><icon name="window-minimize"></icon>&nbsp;{{ $t('message.button.close') }}</b-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import Icon from 'vue-awesome/components/Icon.vue'

  export default {
    components: {
      Icon
    }
  }
</script>

<style>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 800px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #15151a;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>



// WEBPACK FOOTER //
// SnippetOrderModal.vue?c277e3d0